var app_url = 'https://cogapitest.scszsj.com';
// 如果是本地测试环境
if(process.env.NODE_ENV === 'development'){

	app_url = 'https://cogapitest.scszsj.com';  //http://cogapitest.scszsj.com http://gg.com/index.php 

}
// 如果是生产环境，h5环境下直接读取url
if(process.env.NODE_ENV === 'production'){

	// app_url = window.location.protocol+'//' + window.location.host+'/index.php'; http://cogapitest.scszsj.com   https://cogapi.scszsj.com
	app_url = 'https://cogapitest.scszsj.com';

}

export default {
	/*服务器地址*/
	app_url: app_url,
	/*appid*/
	app_id: 10001,
	//h5发布路径
	h5_addr: '/web',
	//inonfont 字体ur
	font_url: 'https://at.alicdn.com/t/font_2184879_i7r5f24ts0d.ttf'
} 
